<template>
  <echarts-com v-loading="loading" id="parkingDensit-parkingSpaceUpdate" :options="options"/>
</template>

<script>
import * as echarts from "echarts";
import {formatRatio} from "@/utils/util";
export default {
  components:{
    echartsCom:()=>import("@/components/echartsCom")
  },
  data() {
    return {
      options:{},
      loading:false
    }
  },
  methods:{
    async getOptions(params={}){
      try {
        this.loading = true;
        let res = await this.$http.post("/statistics/parking/usage",{
          timePoints:["00:00","06:00","08:00","10:00","12:00","14:00","16:00","18:00","20:00","22:00"],
          ...params
        });
        if (res.code === 0) {
          let xAxis_data = []
          let values = []

          for(let item of res.data){
            xAxis_data.push(item.date)
            values.push({
              value: item.usedLots,
              usageRate: formatRatio(item.usageRate),
            })
          }

          this.$set(this, "options", {
            tooltip: {
              trigger: "axis",
              extraCssText: "box-shadow: 0px 0px 13px rgba(0, 193, 153, 0.22);",
              padding: [15, 10],
              formatter: (params) => {
                return `<div>
                  <p>
                    <span style="display: inline-block;width:10px;height:10px;border-radius: 50%;background: linear-gradient(360deg, #F9C253 0%, #FFBB00 100%);"></span>
                    <span>车位使用率:</span>
                    <span>${params[0].data.usageRate}%</span>
                  </p>
                  <p>
                    <span style="display: inline-block;width:10px;height:10px;border-radius: 50%;background: linear-gradient(360deg, #12D5CE 0%, #12D5CE 0%, #2EB6CF 98%, #2EB6CF 100%);"></span>
                    <span>停车数量:</span>
                    <span>${params[0].data.value}</span>
                  </p>
                </div>`;
              },
            },
            xAxis: {
              type: "category",
              data: xAxis_data,
              axisTick: {
                show: false,
              },
              axisLine: {
                lineStyle: {
                  color: "#2a4d69",
                },
              },
              axisLabel: {
                color: "white",
              },
            },
            yAxis: {
              type: "value",
              splitLine: {
                lineStyle: {
                  color: "#2b4a6e",
                  type: "dashed",
                },
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#2a4d69",
                },
              },
              axisLabel: {
                color: "white",
              },
            },
            grid: {
              left: "0%",
              width: "100%",
              height: "90%",
              bottom: "0%",
              containLabel: true, // 包含坐标轴中的文字
            },
            series: [
              {
                type: "bar",
                barMaxWidth: 25,
                itemStyle: {
                  barBorderRadius: [33, 33, 0, 0],
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {offset: 0, color: "#00cec0"},
                    {offset: 1, color: "#9de5e0"},
                  ]),
                },
                data: values,
              },
            ],
          });
        }else{
          this.$message.error(res.msg);
        }
        this.loading = false;
      } catch {
        this.$message.error("车位数量统计获取失败");
        this.loading = false;
      }
    }
  }
}
</script>

<style lang="scss">
#paymentAmountChart {

}
</style>
